if (typeof window.userVerified === 'undefined') {
    window.userVerified = false;
}
if (typeof window.userId === 'undefined') {
    window.userId = 0;
}

export const VerificationManager = {
    props: {
        isAuth: {
            type: Boolean,
            default: false,
        },
        initialPhone: {
            type: String,
            default: '',
        },
        initialEmail: {
            type: String,
            default: '',
        },
        hideEmail: {
            type: Boolean,
            default: false,
        },
        showNameField: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            name: '',
            nameError: '',
            phone: this.initialPhone,
            email: this.initialEmail,
            displayedPhone: this.formatPhone(this.initialPhone),
            smsCode: '',
            verificationCode: '',
            isVerified: false,
            isCodeSent: false,
            phoneError: '',
            emailError: '',
            codeError: '',
            isPhoneValid: false,
            isEmailValid: false,
            isSendingCode: false,
            useEmailVerification: false,
            countdown: 0,
            countdownInterval: null,
            phoneInput: null,
            codeInput: null,
            maskInitialized: false,
            resendAttempts: 0,
            isBlocked: false,
            blockTimeout: null,
            userExists: null,
            serverConsents: [],
            consents: {},
            consentsError: '',
            userCheckError: '',
            checkingUser: false,
        }
    },
    computed: {
        countdownFormatted() {
            const mins = Math.floor(this.countdown / 60)
            const secs = this.countdown % 60
            return `${mins}:${secs < 10 ? '0' : ''}${secs}`
        },
        showPhoneSendButton() {
            return this.isPhoneValid && !this.isCodeSent && !this.isVerified &&
                !this.isAuth
        },
        showEmailSendButton() {
            return this.useEmailVerification &&
                this.isEmailValid &&
                !this.isCodeSent &&
                !this.isVerified
        },
        inputContainerClass() {
            return (this.isPhoneValid || this.isEmailValid) && !this.isCodeSent
                ? 'form-group'
                : 'form-group wd-50'
        },
        verificationCodeModel: {
            get() {
                return this.useEmailVerification
                    ? this.verificationCode
                    : this.smsCode
            },
            set(value) {
                if (this.useEmailVerification) {
                    this.verificationCode = value
                } else {
                    this.smsCode = value
                }
            },
        },
        showResendLink() {
            return this.countdown <= 0 && this.isCodeSent && !this.isVerified &&
                !this.isBlocked
        },
        showConsentsBlock() {
            return !this.isAuth && this.userExists === false &&
                this.serverConsents.length
        },
        showSendCodeButton() {
            return (this.isPhoneValid || this.isEmailValid) &&
                !this.isCodeSent &&
                !this.isVerified &&
                this.userExists !== null && // Проверка пользователя завершена
                !this.checkingUser
        },
        allRequiredConsentsChecked() {
            // Проверяем только обязательные политики
            return this.serverConsents.filter(consent => consent.required).every(consent => this.consents[consent.key])
        },
    },
    methods: {
        validateConsents() {
            this.consentsError = this.allRequiredConsentsChecked
                ? ''
                : 'Необходимо принять все обязательные соглашения'
            return this.allRequiredConsentsChecked
        },
        validateName() {
            this.nameError = this.name.trim().length >= 2
                ? ''
                : 'Имя должно содержать минимум 2 символа'
            return !this.nameError
        },
        formatPhone(phone) {
            if (!phone) return ''
            const cleaned = phone.replace(/\D/g, '')
            const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)
            return match
                ? `+7(${match[2]}) ${match[3]}-${match[4]}-${match[5]}`
                : phone
        },
        initPhoneMask() {

            if (this.phoneInput && this.maskInitialized) {
                $(this.phoneInput).unmask()
            }

            this.phoneInput = this.$el.querySelector('#phone-input')

            if (!this.phoneInput) return

            $(this.phoneInput).mask('+7(999) 999-99-99', {
                completed: () => {
                    this.phone = this.phoneInput.value.replace(/\D/g, '')
                    this.validatePhone()
                },
                onChange: () => {
                    this.displayedPhone = this.phoneInput.value
                },
            })

            if (this.phone) {
                this.phoneInput.value = this.formatPhone(this.phone)
            }

            this.maskInitialized = true
        },
        initCodeMask() {
            if (!this.codeInput) return
            $(this.codeInput).mask('9999', {
                placeholder: '_',
            })
        },
        validatePhone() {
            const digitsOnly = this.phone.replace(/\D/g, '')
            this.isPhoneValid = digitsOnly.length === 11
            this.phoneError = this.isPhoneValid
                ? ''
                : 'Номер должен содержать 11 цифр'
        },
        validateEmail() {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            this.isEmailValid = re.test(this.email)
            this.emailError = this.isEmailValid ? '' : 'Введите корректный email'
            this.$emit('update:email', this.email)
        },
        async sendVerificationCode() {
            if (this.isSendingCode) return
            if (this.showNameField && !this.validateName()) return

            if (this.userExists === false && !this.isAuth &&
                !this.validateConsents()) {
                return
            }

            this.isSendingCode = true
            this.codeError = ''

            try {
                const type = this.useEmailVerification ? 'email' : 'phone'
                const data = {
                    ...(this.useEmailVerification
                        ? {email: this.email}
                        : {phone: this.phone}),
                    ...(this.showNameField && {name: this.name.trim()}),
                    ...(this.userExists === false && !this.isAuth && {
                        consents: Object.keys(this.consents).reduce((acc, key) => {
                            acc[key] = this.consents[key]
                            return acc
                        }, {}),
                    }),
                }

                const response = await this.sendCodeToServer(type, data)

                if (response.status === 'success') {
                    this.isCodeSent = true
                    this.startCountdown(60)
                    this.resendAttempts = 0
                } else {
                    this.codeError = response.message || 'Ошибка при отправке кода'
                }
            } catch (error) {
                this.codeError = 'Ошибка соединения'
            } finally {
                this.isSendingCode = false
            }
        },
        async resendVerificationCode() {
            if (this.isSendingCode || this.isBlocked) return

            // Проверяем количество попыток
            if (this.resendAttempts >= 3) {
                this.blockUser()
                return
            }

            this.isSendingCode = true
            this.codeError = ''

            try {
                const type = this.useEmailVerification ? 'email' : 'phone'
                const data = {
                    ...(this.useEmailVerification
                        ? {email: this.email}
                        : {phone: this.phone}),
                }

                const response = await this.sendCodeToServer(type, data)

                if (response.status === 'success') {
                    this.resendAttempts++
                    this.startCountdown(60)
                } else {
                    this.codeError = response.message || 'Ошибка при отправке кода'
                }
            } catch (error) {
                this.codeError = 'Ошибка соединения'
            } finally {
                this.isSendingCode = false
            }
        },
        blockUser() {
            this.isBlocked = true
            this.codeError = 'Превышено количество попыток. Попробуйте через 15 минут.'

            // Разблокировка через 15 минут
            this.blockTimeout = setTimeout(() => {
                this.isBlocked = false
                this.resendAttempts = 0
                this.codeError = ''
            }, 15 * 60 * 1000) // 15 минут
        },
        async verifyCode() {
            if (this.isSendingCode) return

            this.isSendingCode = true
            this.codeError = ''

            try {
                const type = this.useEmailVerification ? 'email' : 'phone'
                const code = this.verificationCodeModel
                const data = {
                    ...(this.useEmailVerification
                        ? {email: this.email}
                        : {phone: this.phone}),
                    code,
                }

                const response = await this.verifyCodeWithServer(type, data)

                if (response.status === 'success') {
                    this.isVerified = true

                    if (response.data && response.data.user_id) {
                        window.userVerified = true;
                        window.userId = response.data.user_id;
                        console.debug(window.userId);
                    }

                    this.$emit('verification-complete', {
                        verified: true,
                        phone: this.phone,
                        email: this.email,
                        ...(this.showNameField && {name: this.name.trim()}),
                    })

                } else {
                    this.codeError = response.message || 'Неверный код подтверждения'
                }
            } catch (error) {
                this.codeError = 'Ошибка соединения'
            } finally {
                this.isSendingCode = false
            }
        },
        sendCodeToServer(type, data) {
            return new Promise((resolve) => {
                BX.ajax({
                    url: '/api/v1/auth/sendCode/',
                    method: 'POST',
                    data: {...data, type, sessid: BX.bitrix_sessid()},
                    onsuccess: (result) => {
                        try {
                            resolve(JSON.parse(result))
                        } catch {
                            resolve({status: 'error', message: 'Ошибка сервера'})
                        }
                    },
                    onfailure: () => {
                        resolve({status: 'error', message: 'Ошибка соединения'})
                    },
                })
            })
        },
        verifyCodeWithServer(type, data) {
            return new Promise((resolve) => {
                BX.ajax({
                    url: '/api/v1/auth/checkCode/',
                    method: 'POST',
                    data: {...data, type, sessid: BX.bitrix_sessid()},
                    onsuccess: (result) => {
                        try {
                            resolve(JSON.parse(result))
                        } catch {
                            resolve({status: 'error', message: 'Ошибка сервера'})
                        }
                    },
                    onfailure: () => {
                        resolve({status: 'error', message: 'Ошибка соединения'})
                    },
                })
            })
        },
        startCountdown(seconds) {
            clearInterval(this.countdownInterval)
            this.countdown = seconds
            this.countdownInterval = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                    clearInterval(this.countdownInterval)
                }
            }, 1000)
        },
        switchToEmailVerification() {
            this.useEmailVerification = true
            this.resetVerification()
            if (this.phoneInput) {
                $(this.phoneInput).unmask()
            }
        },
        switchToPhoneVerification() {
            this.useEmailVerification = false
            this.resetVerification()
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.initPhoneMask()
                })
            })
        },
        resetVerification() {
            this.isCodeSent = false
            this.codeError = ''
            this.smsCode = ''
            this.verificationCode = ''
            this.resendAttempts = 0
            this.isBlocked = false
            clearTimeout(this.blockTimeout)
        },
        checkUserOnServer(type, data) {
            return new Promise((resolve) => {
                BX.ajax({
                    url: '/api/v1/auth/checkUser/',
                    method: 'POST',
                    data: {...data, type, sessid: BX.bitrix_sessid()},
                    onsuccess: (result) => {
                        try {
                            resolve(JSON.parse(result))
                        } catch {
                            resolve({exists: false, requiredConsents: null})
                        }
                    },
                    onfailure: () => {
                        resolve({exists: false, requiredConsents: null})
                    },
                })
            })
        },
        async validateAndCheckUser() {
            if (this.useEmailVerification) {
                this.validateEmail()
                if (!this.isEmailValid) return
            } else {
                this.validatePhone()
                if (!this.isPhoneValid) return
            }

            await this.checkUserExists()
        },
        async checkUserExists() {
            if (this.checkingUser) return

            this.checkingUser = true
            this.userCheckError = ''

            try {
                const type = this.useEmailVerification ? 'email' : 'phone'
                const data = this.useEmailVerification
                    ? {email: this.email}
                    : {phone: this.phone}

                const response = await this.checkUserOnServer(type, data)
                const result = response.data || {}

                this.userExists = result.exists
                if (!this.userExists && result.consents) {
                    this.serverConsents = result.consents
                    // Инициализируем объект consents
                    this.consents = this.serverConsents.reduce((acc, consent) => {
                        acc[consent.key] = false
                        return acc
                    }, {})
                } else {
                    this.serverConsents = []
                    this.consents = {}
                }

                return this.userExists
            } catch (error) {
                console.error('Ошибка проверки пользователя:', error)
                this.userCheckError = 'Ошибка при проверке пользователя'
                return false
            } finally {
                this.checkingUser = false
            }
        },
    },
    mounted() {
        this.phoneInput = this.$el.querySelector('#phone-input')
        this.codeInput = this.$el.querySelector('#code-input')
        this.initPhoneMask()
        this.initCodeMask()
        if (this.isAuth) {
            if (this.phone) this.validatePhone()
            if (this.email) this.validateEmail()
        }
    },
    watch: {
        phone(newVal) {
            if (this.isPhoneValid && !this.useEmailVerification) {
                this.validateAndCheckUser()
            } else {
                this.userExists = null // Сбрасываем статус при изменении данных
            }
        },
        email(newVal) {
            if (this.isEmailValid && this.useEmailVerification) {
                this.validateAndCheckUser()
            } else {
                this.userExists = null // Сбрасываем статус при изменении данных
            }
        },
        useEmailVerification(newVal) {
            if (!newVal) { // Если переключились обратно на телефон
                this.$nextTick(() => {
                    this.initPhoneMask()
                })
            }
            this.userExists = null
        },
    },
    updated() {
        this.initPhoneMask()
        this.initCodeMask()
    },
    beforeUnmount() {
        clearInterval(this.countdownInterval)
        clearTimeout(this.blockTimeout)
        if (this.phoneInput) {
            $(this.phoneInput).unmask()
        }
        if (this.codeInput) {
            $(this.codeInput).unmask()
        }
    },
    template: `
        <div class="verification-wrapper">
            <div class="verification-main-block">
                <template v-if="isAuth">
                  <div v-if="!useEmailVerification" class="form-group wd-50">
                    <label class="input-trip-name" style="margin-bottom: 5px">Телефон*</label>
                    <div class="verification-container">
                      <div class="input-row">
                        <div class="input-col">
                          <input
                            id="phone-input"
                            v-model="displayedPhone"
                            @input="validatePhone"
                            class="form-control"
                            :class="{ has_error: phoneError }"
                            type="tel"
                            placeholder="+7(999) 999-99-99"
                          >
                        </div>
                      </div>
                      <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
                      <a @click.prevent="switchToEmailVerification" class="switch-method">
                        У меня нет российского номера телефона
                      </a>
                    </div>
                  </div>
                  <div v-if="!hideEmail" class="form-group wd-50">
                    <label class="input-trip-name" style="margin-bottom: 5px">Email*</label>
                    <div class="verification-container">
                      <div class="input-row">
                        <div class="input-col">
                          <input v-model="email" @input="validateEmail"
                                class="form-control" :class="{ has_error: emailError }" type="email"
                                placeholder="Ваш email">
                        </div>
                      </div>
                      <div v-if="emailError" class="error-message">{{ emailError }}</div>
                      <a v-if="useEmailVerification" @click.prevent="switchToPhoneVerification" class="switch-method">
                        У меня есть российский номер телефона
                      </a>
                    </div>
                  </div>
                </template>
            
                <template v-else>
                  <div v-if="!isAuth && showNameField" class="form-group wd-50">
                    <label class="input-trip-name" style="margin-bottom: 5px">Имя*</label>
                    <div class="verification-container">
                      <div class="input-row">
                        <div class="input-col">
                          <input v-model="name" 
                                 @input="validateName"
                                 class="form-control" 
                                 :class="{ has_error: nameError }" 
                                 type="text"
                                 placeholder="Ваше имя">
                        </div>
                      </div>
                      <div v-if="nameError" class="error-message">{{ nameError }}</div>
                    </div>
                  </div>
                  <!-- Блок телефона -->
                  <div v-if="!useEmailVerification && !isCodeSent && !isVerified" :class="inputContainerClass">
                      <label class="input-trip-name" style="margin-bottom: 5px">Телефон*</label>
                      <div class="verification-container">
                          <div class="input-row">
                              <div class="input-col">
                                  <input id="phone-input" v-model="displayedPhone" @input="validatePhone"
                                         class="form-control" :class="{ has_error: phoneError }" type="tel"
                                         placeholder="+7(999) 999-99-99">
                              </div>
                              <div class="button-col" v-if="showSendCodeButton">
                                  <button @click.prevent="sendVerificationCode" 
                                          :disabled="isSendingCode" class="button-orange">
                                      Отправить код
                                  </button>
                              </div>
                          </div>
                          <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
                          <div v-if="userCheckError" class="error-message">{{ userCheckError }}</div>
                          <div v-if="checkingUser" class="loading-message">Проверка пользователя...</div>
                          
                          <a @click.prevent="switchToEmailVerification" class="switch-method">
                              Нет российского номера телефона
                          </a>
                      </div>
                  </div>
                  
                  <!-- Блок кода подтверждения -->
                  <div v-if="isCodeSent && !isVerified" class="form-group">
                      <label class="input-trip-name" style="margin-bottom: 5px">Код подтверждения</label>
                      <div class="verification-container">
                          <div class="input-row">
                              <div class="input-col">
                                  <input id="code-input" v-model="verificationCodeModel"
                                         class="form-control" :class="{ has_error: codeError }" type="text"
                                         placeholder="____" maxlength="4">
                              </div>
                              <div class="button-col">
                                  <button @click.prevent="verifyCode" :disabled="isSendingCode" class="button-orange">
                                      {{ isSendingCode ? 'Проверка...' : 'Подтвердить' }}
                                  </button>
                              </div>
                          </div>
                          <div v-if="codeError" class="error-message">{{ codeError }}</div>
                          <div v-if="countdown > 0" class="countdown">
                              Повторная отправка через {{ countdownFormatted }}
                          </div>
                          <a v-if="showResendLink" @click.prevent="resendVerificationCode" class="switch-method">
                              Отправить код повторно
                          </a>
                      </div>
                  </div>
                  
                  <!-- Блок подтвержденного телефона/email -->
                  <div v-if="isVerified" class="form-group">
                      <label class="input-trip-name" style="margin-bottom: 5px">{{ useEmailVerification ? 'Email' : 'Телефон' }}</label>
                      <div class="verification-container">
                          <div class="input-row">
                              <div class="input-col">
                                  <input class="form-control" 
                                         :value="useEmailVerification ? email : formatPhone(phone)" 
                                         type="text" disabled>
                              </div>
                              <div class="button-col">
                                  <span class="verified-icon">✓</span>
                              </div>
                          </div>
                      </div>
                  </div>
  
                  <!-- Блок email -->
                  <div v-if="useEmailVerification && !isCodeSent" :class="inputContainerClass">
                      <label class="input-trip-name" style="margin-bottom: 5px">Email*</label>
                      <div class="verification-container">
                          <div class="input-row">
                              <div class="input-col">
                                  <input v-model="email" @input="validateAndCheckUser"
                                         class="form-control" :class="{ has_error: emailError }" type="email"
                                         placeholder="Ваш email">
                              </div>
                              <div class="button-col" v-if="showSendCodeButton">
                                  <button @click.prevent="sendVerificationCode" 
                                          :disabled="isSendingCode" class="button-orange">
                                      Отправить код
                                  </button>
                              </div>
                          </div>
                          <div v-if="emailError" class="error-message">{{ emailError }}</div>
                          <div v-if="userCheckError" class="error-message">{{ userCheckError }}</div>
                          <div v-if="checkingUser" class="loading-message">Проверка пользователя...</div>
                          <a v-if="useEmailVerification" @click.prevent="switchToPhoneVerification" class="switch-method">
                              У меня есть российский номер телефона
                          </a>
                      </div>
                  </div>
                  
                  <!-- Блок политик -->
                  <div v-if="showConsentsBlock" class="consents-block">
                    <div class="consent-item" v-for="consent in serverConsents" :key="consent.key">
                      <label class="consent-label">
                        <input 
                          type="checkbox" 
                          v-model="consents[consent.key]" 
                          :required="consent.required"
                        >
                        <span class="consent-text">
                          <span class="consent-text" v-html="consent.text"></span>
                          <span v-if="consent.required" class='requirement'>*</span>
                        </span>
                      </label>
                    </div>
                    
                    <div v-if="consentsError" class="error-message">{{ consentsError }}</div>
                  </div>
                  
                </template>
            </div>
        </div>
    `,
}